// Reconnection policy of the live channel (web spec SW-SY-02), shared with the unit tests.

/** reconnection delays after a WebSocket loss, the last one repeats */
export const RECONNECT_DELAYS_MS = [1_000, 2_000, 5_000, 10_000, 30_000];

/** `/changes` is polled at this pace while the WebSocket is down */
export const OFFLINE_POLL_MS = 15_000;

/**
 * Liveness of the WebSocket (SW-SY-10): a `ping` every PING_MS, and the channel is taken as lost when nothing
 * comes back within PONG_TIMEOUT_MS. Without it, a link that carries nothing any more without any error
 * (Wi-Fi associated without access) kept the console « live » for minutes.
 */
export const PING_MS = 15_000;
export const PONG_TIMEOUT_MS = 10_000;
/** a synchronisation call that has not answered after this delay counts as failed (banner) */
export const SYNC_TIMEOUT_MS = 10_000;

export function reconnectDelay(attempt: number): number {
  return RECONNECT_DELAYS_MS[Math.min(Math.max(attempt, 0), RECONNECT_DELAYS_MS.length - 1)];
}

/** Connection state shown in the workspace header (SW-WS-02): live channel, polling of `/changes`, or server unreachable. */
export type LiveMode = "live" | "polling" | "offline";

export function liveMode(s: { live: boolean; syncFailed: boolean; lastSyncAt: Date | null }): LiveMode {
  if (s.live) return "live";
  if (s.syncFailed || !s.lastSyncAt) return "offline";
  return "polling";
}

/** Changes made by someone else than `me` (display name), for the "modified by" notice (SW-WS-03). */
export function foreignChanges<T extends { actor?: string }>(changes: T[], me: string | undefined): T[] {
  return changes.filter((c) => !!c.actor && c.actor !== me);
}
